import { render, staticRenderFns } from "./MailboxThread.vue?vue&type=template&id=7e118f28&scoped=true"
import script from "./MailboxThread.vue?vue&type=script&lang=js"
export * from "./MailboxThread.vue?vue&type=script&lang=js"
import style0 from "./MailboxThread.vue?vue&type=style&index=0&id=7e118f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e118f28",
  null
  
)

export default component.exports